import { render, staticRenderFns } from "./CloseBatchModal.vue?vue&type=template&id=32690124&scoped=true"
import script from "./CloseBatchModal.vue?vue&type=script&lang=js"
export * from "./CloseBatchModal.vue?vue&type=script&lang=js"
import style0 from "./CloseBatchModal.vue?vue&type=style&index=0&id=32690124&prod&lang=scss&scoped=true"
import style1 from "./CloseBatchModal.vue?vue&type=style&index=1&id=32690124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32690124",
  null
  
)

export default component.exports